import { ColDef } from "ag-grid-community";
import { RowDef } from "../../components/ag-grid-extensions/models/RowDef";
import i18n from "../../services/localization-service/i18n";
import { IUserSiteAccessedInformation  } from "../../services/user-role-administration-service/Models";
// import { Theme } from "@mui/material";
import { getTimeframeTimeDisplayText } from "../../common/utilities/TimeframeUtilities";
import { TimeframeTypeEnum } from "../../common/enums/TimeframeTypeEnum";

const projectRow = (
    entry: IUserSiteAccessedInformation): RowDef => {

    const row: RowDef = {
    };

    row['userID'] =  entry.userID;
    row['userLogin'] = entry.userLogin;
    row['firstName'] = entry.firstName;
    row['lastName'] = entry.lastName;
    row['phoneNumber'] = entry.phoneNumber;
    row['email'] = entry.email;
    row['companyName'] = entry.companyName;
    row['userJobTitle'] = entry.userJobTitle;
    row['userJobFunction'] = entry.userJobFunction;
    row['organization'] = entry.organization;
    row['userDisabled'] = entry.userDisabled;
    row['latestActivity'] = entry.latestActivity ? getTimeframeTimeDisplayText(TimeframeTypeEnum.None, entry.latestActivity) : '';
    row['eLynxDesktop'] = entry.eLynxDesktop ? getTimeframeTimeDisplayText(TimeframeTypeEnum.None, entry.eLynxDesktop) : '';
    row['eLynxMobile'] = entry.eLynxMobile ? getTimeframeTimeDisplayText(TimeframeTypeEnum.None, entry.eLynxMobile) : '';
    row['publicApi'] = entry.publicApi ? getTimeframeTimeDisplayText(TimeframeTypeEnum.None, entry.publicApi) : '';
    
    //row['lastWebsiteLogin'] = entry.lastWebsiteLogin ? getTimeframeTimeDisplayText(TimeframeTypeEnum.None, entry.lastWebsiteLogin) : '';
    //row['scadalynxWebsiteLogin'] = entry.scadalynxWebsiteLogin ? getTimeframeTimeDisplayText(TimeframeTypeEnum.None, entry.scadalynxWebsiteLogin) : '';
    //row['html5MobileString'] = entry.html5MobileString;
    //row['iosDataAccessString'] = entry.iosDataAccessString;
    
    return row;
}

const UserListReportUtils = {

    createGridRows: function (entries: IUserSiteAccessedInformation[] | undefined): RowDef[] {

        const rows: RowDef[] = entries?.map((o) => {

            return projectRow(o);

        }) ?? [];


        return rows;
    },
    createGridColumns: function (/*theme: Theme*/): ColDef[] {

        const cols: ColDef[] = [{
            headerName: i18n.t("adminReports.userID") as string,
            field: 'userID',
            //maxWidth: 128,
            type: "number"
        }, {
            headerName: i18n.t("adminReports.userLogin") as string,
            field: 'userLogin',
            type: "text"
        }, {
            headerName: i18n.t("adminReports.firstName") as string,
            field: 'firstName',
            type: "text"
        }, {
            headerName: i18n.t("adminReports.lastName") as string,
            field: 'lastName',
            //sort: "asc",
            type: "text"
        }, {
            headerName: i18n.t("adminReports.phoneNumber") as string,
            field: 'phoneNumber',
            type: "text, multiline"
        }, {
            headerName: i18n.t("adminReports.email") as string,
            field: 'email',
            type: "text"
        }, {
            headerName: i18n.t("adminReports.companyName") as string,
            field: 'companyName',
            type: "text, multiline"
        }, {
            headerName: i18n.t("adminReports.jobTitle") as string,
            field: 'userJobTitle',
            type: "text, multiline"
        }, {
            headerName: i18n.t("adminReports.jobFunction") as string,
            field: 'userJobFunction',
            type: "text, multiline"
        }, {
            headerName: i18n.t("adminReports.organization") as string,
            field: 'organization',
            type: "text, multiline"
        }, {
            headerName: i18n.t("adminReports.userStatus") as string,
            field: 'userDisabled',
            type: "text"
        }, {
            headerName: i18n.t("adminReports.latestActivity") as string,
            field: 'latestActivity',
            type: "timestamp, multiline"
        }, {
            headerName: i18n.t("adminReports.eLynxDesktop") as string,
            field: 'eLynxDesktop',
            type: "timestamp, multiline"
        }, {
            headerName: i18n.t("adminReports.eLynxMobile") as string,
            field: 'eLynxMobile',
            type: "timestamp, multiline"
        }, {
            headerName: i18n.t("adminReports.publicApi") as string,
            field: 'publicApi',
            type: "timestamp, multiline"
        }];

        return cols;
    },
};

export default UserListReportUtils;
